exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Loading-mask[data-v-6f85f1d8] {\n  width: 100%;\n  height: 100%;\n  z-index: 10000;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #393939;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.Loading-mask #lottie[data-v-6f85f1d8] {\n  width: 400px;\n}", ""]);

// exports
